import React from 'react';
import Icon from './Icon';

export default class Return extends Icon {
  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
    >
      <g fill="#485465" fillRule="evenodd">
        <path d="M20.023 30.471c2.703 0 4.893-2.15 4.893-4.804V14.505c0-.613-.505-1.109-1.129-1.109s-1.13.496-1.13 1.109v11.162c0 1.428-1.179 2.587-2.634 2.587H4.893c-1.455 0-2.635-1.159-2.635-2.587V7.483c0-1.43 1.18-2.588 2.635-2.588H14c.624 0 1.13-.496 1.13-1.108 0-.613-.506-1.11-1.13-1.11H4.893C2.19 2.678 0 4.83 0 7.484v18.184c0 2.653 2.19 4.804 4.893 4.804h15.13z" />
        <path d="M29.592 1.929C29.592.863 29.14.41 28.075.41h-9.643c-1.066 0-1.87.672-1.87 1.738 0 1.065.804 1.708 1.87 1.708h5.013C14.046 14.036 9.286 19.177 9.165 19.28c-.429.443-1.851 1.512-.546 2.915 1.304 1.403 2.52-.03 2.955-.497L26.146 6.561v5.01c0 1.065.717 1.696 1.783 1.696 1.065 0 1.663-.63 1.663-1.696V1.929z" />
      </g>
    </svg>
  );
}
